<template>
  <div>
    <base-header class="pb-6 bg-gradient-dark">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Affiliate List</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb></route-breadcrumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral"
            ><i class="fas fa-user-plus"></i> Invite</base-button
          >
        </div>
      </div>
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Affiliates"
            type="gradient-info"
            :sub-title="`${affiliates.length}`"
            icon="fas fa-users"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Referrals"
            type="gradient-red"
            :sub-title="`${
              affiliates.length
                ? affiliates.map((i) => i.referrals).reduce((a, b) => a + b)
                : 0
            }`"
            icon="fas fa-user-graduate"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Paid Referrals"
            type="gradient-green"
            :sub-title="`${
              affiliates.length
                ? affiliates.map((i) => i.paidReferrals).reduce((a, b) => a + b)
                : 0
            }`"
            icon="fas fa-user-graduate"
          >
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <!--Widgets-->

      <div class="row">
        <div class="col-12">
          <affiliate-table :affiliates="affiliates" />
        </div>
      </div>
      <!--End Widgets-->
    </div>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'

import StatsCard from '@/components/Cards/StatsCard'
import AffiliateTable from './AffiliateTable'

export default {
  components: {
    AffiliateTable,
    StatsCard,
    [Select.name]: Select,
    [Option.name]: Option
  },
  computed: {},
  data() {
    return {
      loader: false,
      affiliates: [],
      key: 0,
      showCreateModal: false,
      affiliate: {},
      statusOptions: [
        {
          label: 'Disabled',
          value: 0
        },
        {
          label: 'Free',
          value: 1
        },
        {
          label: 'Premium',
          value: 2
        }
      ],
      loading: false
    }
  },
  methods: {
    async getAffiliateData() {
      this.loader = this.$loading.show()
      await this.axios
        .get(process.env.VUE_APP_ROOT_API + '/api/v1/affiliates/users')
        .then(({ data }) => (this.affiliates = data))
        .catch(() =>
          this.$notify({
            type: 'danger',
            message: 'Sorry, something went wrong!'
          })
        )
      this.loader.hide()
    }
  },
  mounted() {
    this.getAffiliateData()
  }
}
</script>
<style></style>
